<template>
    <div class="indonesian_leadership_training">
        <div :class="['page_header', language == 'en' ? 'page_header_en' : '']">
            <div class="header_inner">
                <img src="../img/indonesian_leadership/LOGO.png" alt="" class="logo">

                <div class="user_center clearfix">
                    <div class="user-con" v-show="!isLogin">
                        <span class="login-btn" @click="loginFun()">{{ $t("message.login") }}</span>
                        <span> | </span>
                        <span class="register-btn">{{ $t("message.register") }}</span>
                    </div>

                    <div class="login-con" v-show="isLogin"  @click="showUserInfo()">
                        {{user.username}}
                        <span @click="loginOut()">{{language == 'cn' ? '退出' : 'logout'}}</span>
                    </div>
                </div>

                <div class="change_lan" @click="changeLanguage()">
                    <span class="lang-con">{{languageContent}}</span>
                </div>
            </div>
        </div>
        <div class="guset_wrap">
            <div class="page_title" @click="$router.go(-1)">
                < {{language == 'cn' ? '首页' : 'Home'}}/{{language == 'cn' ? liveDetail.name : liveDetail.name_en}}
            </div>
            <div class="cover_wrap">
                <img :src="liveDetail.cover_url" alt="" class="cover">
                <!-- <img src="../img/indonesian_leadership/play_button.png" alt="" class="play_btn" v-if="liveDetail.status == 1 && liveDetail.customStatus == 0 && liveDetail.isOrder == false" @click="join(liveDetail, liveIndex, false)"> -->
                <img src="../img/indonesian_leadership/m/play_button.png" alt="" class="play_btn" v-if="liveDetail.status == 3" @click="replay(liveDetail.video_url)">
                <!-- <img src="../img/indonesian_leadership/play_button.png" alt="" class="play_btn" v-else-if="liveDetail.status == 1 && liveDetail.customStatus == 1" @click="joinToLive(liveDetail, liveIndex)">
                <img src="../img/indonesian_leadership/play_button.png" alt="" class="play_btn" v-else> -->
            </div>

            <div class="guest_info">
                <div class="time">{{new Date(liveDetail.start_time).Format('YYYY.MM.DD hh:mm')}}</div>
                <div class="video_name">{{language == 'cn' ? liveDetail.name : liveDetail.name_en}}</div>
                <div class="guest_name_con">
                    <div class="guest_benqi">{{language == 'cn' ? '授课专家' : 'Teaching Experts'}}：</div>
                    <div class="guest_name">
                        {{language == 'cn' ? liveDetail.teacher_name : liveDetail.teacher_name_en}}
                    </div>
                    <div class="touxian">{{language == 'cn' ? liveDetail.teacher_title : liveDetail.teacher_title_en}}</div>
                    <div class="guest_title">{{language == 'cn' ? liveDetail.organization_name : liveDetail.organization_name_en}}</div>
                </div>
                <div class="info_change">
                    <!-- <span :class="{'active_info': infoIndex == 0}" @click="changeInfo(0)">{{language == 'cn' ? '专家介绍' : 'Expert introduction'}}</span> -->
                    <span>{{language == 'cn' ? '课程介绍' : 'course introduction'}}</span>
                </div>
                <div class="video_desc">
                    {{language == 'cn' ? liveDetail.describe : liveDetail.describe_en}}
                </div>
                <div class="info_change">
                    <span>{{language == 'cn' ? '专家介绍' : 'Expert introduction'}}</span>
                    <!-- <span :class="{'active_info': infoIndex == 1}" @click="changeInfo(1)">{{language == 'cn' ? '课程介绍' : 'course introduction'}}</span> -->
                </div>
                <div class="video_desc">
                    {{language == 'cn' ? liveDetail.teacher_des : liveDetail.teacher_des_en}}
                </div>
            </div>
        </div>


        <transition name="fade">
            <div id="videoPlayWrapper" v-if="isPlay">
                <div class="videoContent">
                    <div class="closeVideo" @click="closeVideo()">×</div>
                    <ali-player
                    v-if="isPlay"
                    :useFlashPrism="false"
                    :useH5Prism='true'
                    :autoplay="true"
                    :isLive="false"
                    :rePlay="false"
                    :showBuffer="true"
                    showBarTime="5000"
                    width="95%" 
                    height="400px" 
                    controlBarVisibility="always"
                    :source="currentVideoUrl"></ali-player>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import Qs from 'qs'
import aliPlayer from '../pc/aliplayer'

export default {
  data () {
    return {
      isLogin: false,
      userInfoShow: false,
      languageContent: 'Chinese',
      languageMap: {
        'cn': 'English',
        'en': 'Chinese'
      },
      liveDetail: {},
      liveIndex: '',
    isPlay: false,
    infoIndex: 0,
    currentVideoUrl: '',
    user: {
        username: '',
        email: ''
    },
    subject_info: {},
    courseList: [],
    subject_id: null,
    beforeTime: 30, // 提前可进入直播间时间
    afterTime: 30 // 延后关闭直播间时间
    }
  },
  components: {
    aliPlayer
  },
  computed: {
    language () {
      return this.$i18n.locale
    }
  },
  created () {
    this.languageContent = this.languageMap[this.language]
    this.customCheckLogin()
    this.getCourseInfo()
  },
  methods: {
    customCheckLogin() {
        this.checkLogin().then(res => {
            if(res.data.success){
                this.isLogin = true
                this.user = res.data.data
            } else {
                this.isLogin = false
            }
        }).catch((r) => {
            console.log(r)
        })
    },
    // 点击弹出框 用户信息
    showUserInfo () {
      this.userInfoShow = !this.userInfoShow
    },
    // 登录
    loginFun () {
        window.location.href = 'https://z.chineseplus.net/' + "user/api/login?" + "callback=" + encodeURIComponent(window.location.href);
    },
    // 退出登录
    loginOut () {
      this.$utils.get('/user/api/logout', { }).then (res => {
        if (res.data.success) {
          window.location.reload()
        }
      })
    },
    // 切换语言
    changeLanguage () {
      const data = localStorage.getItem('localeLanguage') == 'cn' ? 'en' : 'cn'
      localStorage.setItem('localeLanguage', data)
    //   let data = this.language == 'cn' ? 'en' : 'cn'
      this.$i18n.locale = data
      this.languageContent = this.languageMap[data]
    //   location.reload()
    },
    changeInfo (i) {
        this.infoIndex = i
    },
    // 点击获取直播详情
    getLiveDetail (v, i) {
        this.liveDetail = v
        this.liveIndex = i
    },
    // 获取课程列表
    getCourseInfo(id) {
        this.$utils.get('/subject/lesson/getlist', {
            // subject_id: 117,
            subject_id: 130,
            limit: 200
        }).then(res => {
            if(res.data.success) {
                var now = new Date().getTime()
                var endTime = now - this.afterTime * 60 * 1000;
                var nowBeforeFiveMin = now + this.beforeTime * 60 * 1000
                res.data.data.list.forEach(e => {
                    e.isOrder = false
                    e.customStatus = 0
                    if (nowBeforeFiveMin > e.start_time) {
                        e.customStatus = 1 // 0:直播未开始 1:正在直播 2：直播已结束
                    }
                    if (endTime > e.end_time) {
                        e.customStatus = 2
                    }
                    if (e.extra) {
                        e.teacher_des = e.extra.teacher_des
                        e.teacher_des_en = e.extra.teacher_des_en
                    } else {
                        e.teacher_des = ''
                        e.teacher_des_en = ''
                    }
                })
                this.courseList = res.data.data.list
                this.liveDetail = this.courseList.find(v => v.id == this.$route.query.id)
                // this.checkOrderList()
            }
        }).catch((r) => {
            console.log(r)
        })
    },
    // 检查可预约直播间
    checkOrderList() {
        const orderRoomId = []
        this.courseList.forEach(e => {
            if (orderRoomId.indexOf(e.room_id) == -1 && e.room_id != 0) {
                orderRoomId.push(e.room_id)
            }
        })
        this.checkRoomsIsOrder(orderRoomId)
    },
    // 检查用户直播间状态
    checkRoomsIsOrder() {
        const data = Qs.stringify({
            rooms: [this.liveDetail.room_id].toString(),
            user: this.user.email
        })
        this.$utils.thirdPost('https://mooc-stage.chinesecio.com/api/live/get_user_rooms'+"?time=" +new Date().valueOf(), data, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then(res => {
            if (res.data.code == 0) {
                if (res.data.data.hasOwnProperty(this.liveDetail.room_id)) {
                    this.isPlay = true
                    this.currentVideoUrl = this.liveDetail.video_url
                }
                // this.isPlay = true
                // this.currentVideoUrl = url
                // this.courseList.forEach((e, index) => {
                //     if (res.data.data.hasOwnProperty(e.room_id)) {
                //         this.courseList[index].isOrder = true
                //         this.$set (this.courseList, index, this.courseList[index])
                //     }
                // })
            } else {
                alert(res.data.msg)
            }
        }).catch((r) => {
            console.log(r)
        })
    },
    join(item, index, islive) {
        if(!this.isLogin) {
            this.loginFun()
            return
        }
        const data = Qs.stringify({
            room_id: item.room_id,
            user: this.user.email,
            secret: "03198325b8b61ccc3413cf7e754febea",
            key: "zyz",
            username: this.user.username,
            realname: this.user.username
        })
        this.$utils.thirdPost('https://mooc-stage.chinesecio.com/api/live/add_user'+"?time=" +new Date().valueOf(), data, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then(res => {
            if (res.data.code == 0) {
                this.courseList[index].isOrder = true
                this.$set (this.courseList, index, this.courseList[index])
                if (islive) {
                    window.location.href = 'https://mooc-stage.chinesecio.com/index/login/index.html?room_id=' + item.room_id
                }
            }
        }).catch((r) => {
            console.log(r)
        })
    },
    joinToLive(item, index) {
        if(!this.isLogin) {
            this.loginFun()
            return
        }
        if(!item.isOrder) {
            this.join(item, index, true)
        }else {
            window.location.href = 'https://mooc-stage.chinesecio.com/index/login/index.html?room_id=' + item.room_id
        }
    },
    replay(url) {
        if(!this.isLogin) {
            this.loginFun()
            return
        } else {
            this.checkRoomsIsOrder()
        }
    },
    closeVideo() {
        this.isPlay = false
    },
  }
}
</script>

<style scoped lang="scss">
.indonesian_leadership_training {
    width: 100%;
    // height: 100%;
    position: relative;
    font-family: 'Microsoft YaHei';
    .page_header {
        padding: 0 .44rem;
        padding-top: .47rem;
        box-sizing: border-box;
        width: 100%;
        height: 5.54rem;
        background: url('../img/indonesian_leadership/m/banner.png') no-repeat center;
        background-size: cover;
        background-color: #e6e6e6;
        &.page_header_en {
            background: url('../img/indonesian_leadership/m/banner_en.png') no-repeat center;
            background-size: cover;
        }
        .header_inner {
            margin: auto;
            .logo {
                width: 2.45rem;
                float: left;
            }
            .change_lan {
                float: right;
                width: 2rem;
                height: .6rem;
                background-color: #d9b47f;
                border-radius: .04rem;
                color: #fff;
                text-align: center;
                line-height: .6rem;
                cursor: pointer;
                font-size: .39rem;
            }
            .user_center {
                float: right;
                font-size: .39rem;
                padding-top: .1rem;
                .user-con {
                    float: left;
                    margin-left: .3rem;
                    color: #a17e4b;
                    .login-btn {
                    cursor: pointer;
                    }
                    .register-btn {
                    cursor: pointer;
                    }
                }
                .login-con {
                    float: left;
                    margin-left: .5rem;
                    margin-right: .4rem;
                    position: relative;
                    span {
                        cursor: pointer;
                        padding-left: .1rem;
                    }
                    .user-img {
                    width: 30px;
                    border: 1px solid #f5f5f5;
                    padding: 3px;
                    border-radius: 50%;
                    vertical-align: middle;
                    cursor: pointer;
                    }
                    .user-box {
                    border: 1px solid #ccc;
                    position: absolute;
                    top: 45px;
                    right: -20px;
                    font-size: 18px;
                    width: 90px;
                    line-height: 30px;
                    overflow: hidden;
                    display: block;
                    border-radius: 5px;
                    text-align: center;
                    & li {
                        display: inline-block;
                        width: 100%;
                        height: 30px;
                        color: #009dcd;
                        background: #fff;
                        cursor: pointer;
                    }
                    }
                }
            }
        }

    }

    .guset_wrap {
      width: 100%;
      margin: auto;
      margin-top: .42rem;
      padding: 0 .45rem;
      box-sizing: border-box;
      .page_title {
          font-size: .36rem;
          color: #1f67c6;
          padding-bottom: .26rem;
          line-height: 1.4;
      }
      .cover_wrap {
        height: 5.79rem;
        border-radius: 20px;
        position: relative;
        .cover {
          width: 100%;
          height: 100%;
          border-radius: 10px;
        }
        .play_btn {
          width: 1.2rem;
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          margin: auto;
          cursor: pointer;
        }
      }

      .guest_info {
        width: 100%;
        .time {
          font-size: .36rem;
          color: #036eb8;
          margin-bottom: .19rem;
          margin-top: .29rem;
        }
        .video_name {
          font-weight: bold;
          font-size: .45rem;
          color: #3c3c3c;
          margin-bottom: .38rem;
          line-height: 1.2;
        }
        .guest_name_con {
          .guest_benqi {
            font-size: .39rem;
            color: #1f1f3b;
            margin-bottom: .17rem;
          }
          .guest_name {
            font-size: .36rem;
            color: #036eb8;
            font-weight: bold;
            margin-bottom: .18rem;
          }
          .touxian {
              font-weight: normal;
              font-size: .36rem;
              color: #036eb8;
              margin-bottom: .18rem;
          }
            .guest_title {
                font-weight: normal;
                font-size: .36rem;
                color: #036eb8;
                padding-bottom: .28rem;
                border-bottom: 0.01rem solid #e6e6e6;
            }
        }
        .info_change {
            color: #000;
            font-size: .45rem;
            padding-top: .3rem;
            padding-bottom: .0rem;
            font-weight: bold;
            span {
                cursor: pointer;
                &.active_info {
                    color: #036eb8;
                    font-weight: bold;
                    text-decoration: underline;
                }
            }
            span:nth-child(1) {
                margin-right: 8px;
            }
        }
        .video_desc {
          font-size: .36rem;
          line-height: 1.6;
          color: rgba(0, 0, 0, .8);
          word-break: break-word;
          margin-top: .3rem;
          padding-bottom: .1rem;
        }
      }
    }
    #videoPlayWrapper {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.8);
        z-index: 999;
    }
    #videoPlayWrapper .closeVideo {
        position: absolute;
        right: .2rem;
        top: .1rem;
        font-size: 1rem;
        color: #fff;
        cursor: pointer;
    }
    .videoContent {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>
